import UAParser from 'ua-parser-js'

const result = (new UAParser(window.navigator.userAgent)).getResult();

const useragent = {
  result,
  // OS
  isWindows: result.os.name === 'Windows',
  isLinux: result.os.name === 'Linux',
  isAndroid: result.os.name === 'Android',
  isIOS: result.os.name === 'iOS',
  isChromiumOS: result.os.name === 'Chromium OS',
  isMacOS: result.os.name === 'Mac OS',
  isDesktopOS: ['Windows', 'Linux', 'Chromium OS', 'Mac OS'].includes(result.os.name),
  // Engines
  isBlink: result.engine.name === 'Blink',
  isGecko: result.engine.name === 'Gecko',
  isWebKit: result.engine.name === 'WebKit',
}

export default useragent;
